module.exports = __webpack_public_path__ + "img/swap.f2092ae7.svg";